export const AiAssistant = () => {
  return <div className="h-[398px] w-full rounded-xl bg-dark-container"></div>;
};
